export enum AddressTypeEnum {
    HOME = 'HOME',
    WORK = 'WORK'
}
